import { InjectionToken } from '@angular/core';
import { LpUiConfig } from '../models/config.model';

export const LP_UI_CONFIG = new InjectionToken<LpUiConfig>('LP_UI_CONFIG');
